import { Logo2 } from "@shared/components/Logo";

interface HeadingProps {
  logo?: boolean;
}

export function Heading({ logo = true }: HeadingProps) {
  return (
    <div className="mb-5">
      <div className="flex items-center gap-x-2 mb-4">
        {logo && (
          <div className="flex justify-center items-center size-9">
            <Logo2 />
          </div>
        )}
        <h1 className="text-4xl font-display">Chat Upload Portal</h1>
      </div>
    </div>
  );
}
